import React, { useEffect, useState } from 'react';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import HowToPage from './components/HowToPage';
import CoursesPage from './components/CoursesPage';
import CourseDetailPage from './components/CourseDetailPage';
import PremiumPage from './components/PremiumPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsOfServicePage from './components/TermsOfServicePage';
import ResetPasswordPage from './components/ResetPasswordPage';
import ComingSoonModal from './components/ComingSoonModal';

function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const [isComingSoonModalOpen, setIsComingSoonModalOpen] = useState(false);

  // Handle scrolling to sections when page loads with hash
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Small delay to ensure page is fully loaded
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  // Listen for navigation changes
  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);
  
  if (currentPath === '/how-to') {
    return <HowToPage />;
  }
  
  if (currentPath === '/courses') {
    return <CoursesPage />;
  }
  
  if (currentPath.startsWith('/course/')) {
    return <CourseDetailPage />;
  }
  
  // if (currentPath === '/club') {
  //   return <ClubPage />;
  // }
  
  if (currentPath === '/premium') {
    return <PremiumPage />;
  }
  
  if (currentPath === '/privacy') {
    return <PrivacyPolicyPage />;
  }
  
  if (currentPath === '/terms') {
    return <TermsOfServicePage />;
  }

  if (currentPath === '/reset-password') {
    return <ResetPasswordPage />;
  }
  
  // Default homepage
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <FAQ />
      </main>

      {/* Final CTA Section */}
      <section className="py-28 sm:py-36 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Ready to Take Your Shot?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Join the waitlist and be the first to know when Hole In 1 launches.
            </p>
            <button
              onClick={() => setIsComingSoonModalOpen(true)}
              className="px-8 py-4 text-white font-semibold text-lg rounded-xl transition-colors hover:opacity-90"
              style={{ backgroundColor: '#9CB75A' }}
            >
              Join the Waitlist
            </button>
          </div>
        </div>
      </section>

      <Footer />

      <ComingSoonModal
        isOpen={isComingSoonModalOpen}
        onClose={() => setIsComingSoonModalOpen(false)}
      />
    </div>
  );
}

export default App;
